import { Center, Flex, Icon, Text, Button } from '@chakra-ui/react';
import { getThemeDetails } from 'assessment/pages/utils';

export const UnsubscribeWrapper = ({
  header,
  subHeader,
  infoText,
  showCta,
  ctaText,
  icon,
  onCtaClick,
  isCtaLoading,
}) => {
  const { secondaryColor, primaryColor, tertiaryColor, textColor } =
    getThemeDetails({});

  return (
    <Center bg={secondaryColor} h="100vh" w="100%" flexDir="column">
      <Center flex="1">
        <Flex
          border="1px solid"
          borderColor="border-color"
          borderRadius="sm"
          p="32px 43px"
          bg="#fff"
          boxShadow="0px 3px 6px 0px #C7C7C71A,0px 11px 11px 0px #C7C7C717,0px 26px 15px 0px #C7C7C70D,0px 45px 18px 0px #C7C7C703,0px 71px 20px 0px #C7C7C700"
          flexDir="column"
          gap="24px"
          alignItems="center"
          maxW="700px"
        >
          <Center w="72px" h="72px" bg={tertiaryColor} borderRadius="full">
            <Icon as={icon} width="30px" height="30px" color={primaryColor} />
          </Center>
          {header && (
            <Text size="xl-semi-bold" textAlign="center">
              {header}
            </Text>
          )}
          {subHeader && (
            <Text size="md-medium" textAlign="center">
              {subHeader}
            </Text>
          )}

          {showCta && (
            <Button
              variant="primary"
              bg={primaryColor}
              color={textColor}
              onClick={onCtaClick}
              _hover={{}}
              _active={{}}
              borderRadius="full"
              isLoading={isCtaLoading}
            >
              {ctaText}
            </Button>
          )}
        </Flex>
      </Center>
    </Center>
  );
};
